import React from 'react';
import ClaimFieldsTable from './ClaimFieldsTable';
export default function ProfitsChargealbeToCorporationTaxTable(_ref) {
  let {
    claim,
    setClaim,
    calculations,
    refreshCalculations
  } = _ref;
  const calculationOfProfitsChargeableToCorporationTaxRows = [{
    text: 'Trading profit',
    field_1: {
      name: 'trading_profit_1'
    },
    field_2: {
      name: 'trading_profit_2'
    }
  }, {
    text: 'NTLR income',
    field_1: {
      name: 'ntlr_income',
      editable: true
    },
    field_2: {
      name: 'ntlr_income'
    }
  }, {
    text: 'Property Income',
    field_1: {
      name: 'property_income',
      editable: true
    },
    field_2: {
      name: 'property_income'
    }
  }, {
    text: 'Other Income',
    field_1: {
      name: 'other_income',
      editable: true
    },
    field_2: {
      name: 'other_income'
    }
  }, {
    text: 'Other deductions',
    field_1: {
      name: 'other_deductions',
      editable: true
    },
    field_2: {
      name: 'other_deductions'
    }
  }, {
    text: 'Loss reliefs',
    field_1: {
      name: 'loss_reliefs',
      editable: true
    },
    field_2: {
      name: 'loss_reliefs'
    }
  }, {
    className: 'font-weight-bold',
    text: 'Total Taxable Profit',
    field_1: {
      name: 'total_taxable_profit_1'
    },
    field_2: {
      name: 'total_taxable_profit_2'
    }
  }, {
    className: 'color-red',
    text: 'Check of above',
    field: {
      name: null
    }
  }, {
    className: 'ps-5',
    text: 'Total Taxable Profit per tax comp',
    field_1: {
      name: 'total_taxable_profit_per_tax_comp',
      editable: true
    },
    field_2: {
      name: 'total_taxable_profit_per_tax_comp',
      editable: true
    }
  }, {
    className: 'ps-5',
    text: 'Reconciliation',
    field: {
      name: null
    }
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "Calculation of Profits Chargeable to Corporation Tax",
    rows: calculationOfProfitsChargeableToCorporationTaxRows
  });
}